import PublicLayout from '@/components/public/PublicLayout';
import Hero from '@/components/public/Hero';
import AttractionsPreview from '@/components/public/AttractionsPreview';
import AventuraParaTodos from '@/components/public/AventuraParaTodos';
import CumpleEventosSection from '@/components/public/CumpleEventosSection';
import SafetySection from '@/components/public/SafetySection';
import SocialWall from '@/components/public/SocialWall';
import Gallery from '@/components/public/Gallery';
import CelebrateCTASection from '@/components/public/CelebrateCTASection';
import LocationContact from '@/components/public/LocationContact';

export default function HomePage() {
    return (
        <PublicLayout>
            <Hero />
            <Gallery />
            <AttractionsPreview />
            <AventuraParaTodos />
            <CumpleEventosSection withForm={false} />
            <SafetySection />
            <SocialWall />
            <CelebrateCTASection />
            <LocationContact/>
        </PublicLayout>
    );
}
